<template>
  <div class="indexPage custom_style">
    <div class="head flex-rowl">
      <i class="iconfont icon-huiyuan"></i>
      <div class="content">
        <h1>物流信息</h1>
        <p>收件物流信息管理</p>
      </div>
    </div>
    <div class="container_wrap">
      <div class="form_wrap">
        <div class="block">
          <div class="item">
            <div class="label"><i class="iconfont icon-bitian"></i> 姓名</div>
            <div class="input">
              <van-field v-model="formData.truename" placeholder="请输入姓名" />
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label"><i class="iconfont icon-bitian"></i> 手机号</div>
          <div class="input">
            <van-field v-model="formData.mobile" placeholder="请输入手机号" />
          </div>
        </div>
        <div class="item">
          <div class="label">物流信息类型</div>
          <van-radio-group
            v-model="formData.runtype"
            direction="horizontal"
            icon-size="18px"
          >
            <van-radio name="1">私人</van-radio>
            <van-radio name="2">办公</van-radio>
          </van-radio-group>
        </div>

        <div class="block address_wrap">
          <div class="label">所在地区</div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(1)">
              <van-field
                v-model="provinceTxt"
                placeholder="选择省/直辖市"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(2)">
              <van-field v-model="cityTxt" placeholder="选择城市" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(3)">
              <van-field
                v-model="areaTxt"
                placeholder="选择所在区域"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item detail">
            <div class="tit">详细地址</div>
            <div class="textarea">
              <van-field
                v-model="formData.addr"
                type="textarea"
                placeholder="请填写详细地址，50个字符内"
              />
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label">是否默认</div>
          <van-radio-group
            v-model="formData.isdefault"
            direction="horizontal"
            icon-size="18px"
          >
            <van-radio name="是">是</van-radio>
            <van-radio name="不是">不是</van-radio>
          </van-radio-group>
        </div>
        <div class="item">
          <div class="label">是否启用</div>
          <van-radio-group
            v-model="formData.isuse"
            direction="horizontal"
            icon-size="18px"
          >
            <van-radio name="1">启用</van-radio>
            <van-radio name="0">停用</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="custom_btn" @click="query">保存</div>
    </div>
    <!-- <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div> -->
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <!-- 弹窗 start -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 2">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 4">
        <van-picker
          show-toolbar
          :columns="columnOne"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 5">
        <van-picker
          show-toolbar
          :columns="columnTwo"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 6">
        <van-picker
          show-toolbar
          :columns="columnThree"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 7">
        <van-picker
          show-toolbar
          :columns="customerQy"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  encryptstringview,
} from "../../../api/api";
import {
  editCustomAddress,
  addCustomAddress,
  getCustomAddressDetail,
} from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "updateCustomer",
  data() {
    return {
      id: "",
      qyguid: "",
      type: "",
      formData: {
        id: "",
        guid: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        zipcode: "",
        isdefault: "不是", // 是否默认 =是 不是
        truename: "",
        mobile: "",
        runtype: "", // 物流信息类型 =1=私人 2=办公
        isuse: "0", // 是否启用 =1=启用 0=停用
      },

      columnOne: [],
      columnTwo: [],
      columnThree: [],

      customerOptin: [],
      customerQy: [],

      isType: 1,
      provinceList: [],
      provinceTxt: "",
      cityList: [],
      cityTxt: "",
      areaList: [],
      areaTxt: "",
      loading: true,
      isShowPopup: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, addressId, customerGuid } = JSON.parse(res.jsondata);
        this.id = id;
        this.formData.id = addressId == 0 ? "" : addressId;
        this.formData.guid = customerGuid;
        this.getCustomAddressDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomAddressDetail() {
      let params = {
        id: this.formData.id,
        guid: this.formData.guid,
      };
      getCustomAddressDetail(params).then((res) => {
        this.formData.truename = res.truename;
        this.formData.mobile = res.mobile;
        this.formData.isdefault = res.isdefault;
        this.formData.runtype = res.runtype;
        this.formData.isuse = res.isuse;
        this.formData.province = res.province ? parseInt(res.province) : "";
        this.provinceTxt = res.provincestr;
        this.formData.city = res.city ? parseInt(res.city) : "";
        this.cityTxt = res.citystr;
        this.formData.area = res.area ? parseInt(res.area) : "";
        this.areaTxt = res.areastr;
        this.formData.addr = res.addr;
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        let newProvince = [];
        res.forEach((v) => {
          newProvince.push({
            text: v.areaname,
            id: v.areaid,
          });
        });
        this.provinceList = newProvince;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.other_province).then((res) => {
        let newcity = [];
        res.forEach((v) => {
          newcity.push({
            text: v.cityname,
            id: v.cityid,
          });
        });
        this.cityList = newcity;
        this.loading = false;
        if (isClick && newcity.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.formData.other_city).then((res) => {
        let newarea = [];
        res.forEach((v) => {
          newarea.push({
            text: v.addrname,
            id: v.addrid,
          });
        });
        console.log();
        this.areaList = newarea;
        this.loading = false;
        if (isClick && newarea.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    onConfirm(e) {
      let { isType } = this;
      let { text, id } = e;
      console.log(id, text);
      if (isType == 1) {
        this.provinceTxt = text;
        this.formData.province = id;
        this.areaTxt = "";
        this.formData.area = "";
        this.cityTxt = "";
        this.formData.city = "";
        this.formData.addr = "";
      } else if (isType == 2) {
        this.cityTxt = text;
        this.formData.city = id;
        this.areaTxt = "";
        this.formData.area = "";
        this.formData.addr = "";
      } else if (isType == 3) {
        this.areaTxt = text;
        this.formData.area = id;
        this.formData.addr = "";
      } else if (isType == 7) {
        this.formData.other_company = text;
      }
      this.loading = true;
      this.isShowPopup = false;
    },
    // 显示弹窗
    handleShow(type) {
      let { provinceTxt, cityTxt } = this;
      this.isType = type;
      if (type == 1) {
        this.getProvince(true);
      } else if (type == 2) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        this.getCity(true);
      } else if (type == 3) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        if (cityTxt == "") {
          this.$toast("请选择城市");
          return;
        }
        this.getArea(true);
      } else if (type == 4) {
        this.getQywxset(true);
      } else if (type == 5) {
        this.getQywxset(true);
      } else if (type == 6) {
        this.getQywxset(true);
      } else if (type == 7) {
        this.getCustomQyList();
      }
    },

    query() {
      let { formData } = this;
      if (formData.truename == "") {
        this.$toast("请输入姓名");
        return;
      }
      if (formData.mobile == "") {
        this.$toast("请输入手机号");
        return;
      }
      if (formData.province == "") {
        this.$toast("请选择地址");
        return;
      }
      if (formData.id == "") {
        this.addCustomAddress();
      } else {
        this.editCustomAddress();
      }
    },

    addCustomAddress() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCustomAddress(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    editCustomAddress() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCustomAddress(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  /deep/ .van-cell {
    padding: 0;
    font-size: 12px;
    background: none;
    height: 100%;
  }
  /deep/ .van-field__body {
    height: 100%;
  }
  .head {
    .icon-huiyuan {
      font-size: 42px;
      font-weight: 500;
    }
  }
  .container_wrap {
    padding: 75px 83px 56px;
    .form_wrap {
      font-size: 24px;
      color: #333333;
      .customer_wrap {
        margin: 59px 13px 0;
        .label_list {
          margin-top: 30px;
          .item {
            font-size: 20px;
            color: #464646;
            height: 40px;
            border: 1px solid #d2d2d2;
            padding: 0 10px 0 20px;
            margin-right: 10px;
            min-width: 120px;
            box-sizing: border-box;
            .iconfont {
              font-size: 36px;
              margin-left: 15px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .classify_wrap {
        margin: 90px 0 110px;
      }
      .address_wrap {
        .title {
          margin-bottom: 59px;
        }
      }
      .item {
        margin-bottom: 32px;
        .tit {
          margin-bottom: 20px;
        }
        .label {
          margin-bottom: 25px;
          .iconfont {
            color: #c63520;
            margin-left: -12px;
          }
        }
        .input {
          border-bottom: 1px dashed #c3c3c3;
          height: 60px;
          padding: 0 12px;
        }
        .textarea {
          height: 190px;
          background: #fafafa;
          padding: 10px 20px;
          box-sizing: border-box;
          /deep/ .van-field__control {
            height: 100%;
          }
        }
        &.detail {
          margin-top: 70px;
        }
      }
    }
    .custom_btn {
      margin-top: 200px;
      width: 280px;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>